/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum GetBookingV2Response_BookingState {
    FROZEN = 'FROZEN',
    PAID = 'PAID',
    SHOPCART = 'SHOPCART',
    CLEANED = 'CLEANED',
    BOOKED = 'BOOKED',
}
